(function ($, window) {
    const qnonce = settings.nonce;
    $(document).on('click', '.quick-view-js', function () {
        window.code_happened = false;
        $.ajax({
            type: "POST",
            url: ajaxurl,
            data: {
                action: 'prodigy-quick-edit',
                post_id: $(this).data('id'),
                nonce: qnonce
            },
            cache: false,
            success: function (html) {
                $.magnificPopup.open({
                    items: {
                        src: '#quick-view-js',
                    },
                    type: 'inline',
                    callbacks: {
                        beforeOpen: function () {
                            $('#quick-view-content-js').html(html);
                            prodigyProduct.init();
                            if (!prodigyProduct.is_variants()) {
                                prodigyProduct.get_master_variant_data();
                            }
                            prodigyProduct.set_elementor_options();
                            prodigyProduct.set_product_counter();
                            if (prodigyProduct.is_swatches()) {
                                prodigyProduct.change_swatch_value();
                                prodigyProduct.set_checked_swatch();
                            }
                            prodigyProduct.add_item_to_cart();
                            prodigyProduct.reset_focus_to_press_enter();

                            prodigyProductBulk.bulk_showing_manager();
                            if (prodigyProduct.is_tiered_price) {
                                prodigyProduct.get_tiered_prices_range_ajax();
                            }
                            prodigyProductBulk.set_bulk_variants_data();
                            if (prodigyProduct.is_bulk()) {
                                prodigyProduct.set_bulk();
                            }
                        },
                        open: function () {
                            prodigyProduct.update_variants_dropdown();
                            prodigyProduct.set_product_gallery();
                            prodigyProduct.set_attribute_value_options();
                        },
                    }
                });
            }
        });


        $(document).on('click', '.quick-view-close', '.filter-close', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    });
})(jQuery, window);